import BaseService from './baseService';

export default {
  getFornecedoresCadastrados() {
    return BaseService.get("fornecedor/ListarFornecedoresUsuarioCadastrador");
  },

  cadastroinicial(model) {
    return BaseService.post('fornecedor/cadastroinicial', model);
  },

};
